import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EnvironmentService } from '../environment/environment.service';
import { MatDialog } from '@angular/material/dialog';
import { User } from "../interfaces/user";
import { BehaviorSubject } from "rxjs";
// import { Apollo } from "apollo-angular";

// Domain previously shared across *.creaweb.com subdomains so one cookie
// could serve multiple apps. Environments that no longer use a shared
// domain (see EnvironmentService.cookieDomain) must proactively clear it,
// since a leftover cookie from before the migration has the same name/path
// and, being older, sorts ahead of the new cookie in document.cookie -
// silently shadowing it and leaving users stuck on the login screen.
const LEGACY_COOKIE_DOMAIN = '.creaweb.com';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  call_running: number = 0;
  constructor(
    private cookie: CookieService,
    private router: Router,
    private environment: EnvironmentService,
    private dialog: MatDialog
  ) {
    if (this.environment.cookieDomain !== LEGACY_COOKIE_DOMAIN) {
      this.cookie.delete('token', '/', LEGACY_COOKIE_DOMAIN);
    }

    // private apollo: Apollo
    if (window.location.href.includes('code=')) {
      localStorage.setItem(
        'auth_code',
        window.location.href.substring(
          window.location.href.indexOf('code=') + 5,
          window.location.href.indexOf('&session')
        )
      );
      if (!this.router.isActive('/login', true)) {
        this.dialog.closeAll();
        this.router.navigate(['/login'], { skipLocationChange: false });
      }
    }
  }

  getToken() {
    let tokenstr: string = this.cookie.get('token');
    if (
      tokenstr !== null &&
      tokenstr !== '' &&
      tokenstr !== undefined &&
      tokenstr !== 'null'
    ) {
      let token = JSON.parse(tokenstr);
      if (token[this.environment.env_name]) {
        return token[this.environment.env_name].token;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getWholeToken() {
    let tokenstr: string = this.cookie.get('token');
    if (
      tokenstr !== null &&
      tokenstr !== '' &&
      tokenstr !== undefined &&
      tokenstr !== 'null'
    ) {
      let token = JSON.parse(tokenstr);
      if (token[this.environment.env_name]) {
        return token[this.environment.env_name];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  updateTokenProperty(propname: string, propval: any) {
    let fulltoken = this.getTokenAllEnvs();
    fulltoken[this.environment.env_name][propname] = propval;
    this.cookie.set(
      'token',
      decodeURIComponent(JSON.stringify(fulltoken)),
      new Date('2099-09-18'),
      '/',
      this.environment.cookieDomain
    );
  }

  getTokenAllEnvs() {
    let tokenstr: string = this.cookie.get('token');
    if (
      tokenstr !== null &&
      tokenstr !== '' &&
      tokenstr !== undefined &&
      tokenstr !== 'null'
    ) {
      let token = JSON.parse(tokenstr);
      return token;
    } else {
      return null;
    }
  }

  login(token: any) {
    let fulltoken = this.getTokenAllEnvs();
    if (!fulltoken) {
      fulltoken = {};
    }
    fulltoken[this.environment.env_name] = token.createSsoToken;
    this.cookie.set(
      'token',
      decodeURIComponent(JSON.stringify(fulltoken)),
      new Date('2099-09-18'),
      '/',
      this.environment.cookieDomain
    );
  }

  logout(error: boolean = false) {
    // this.apollo.getClient().resetStore();
    this.clearToken();
    if (error && this.router.url !== '/login') {
      localStorage.setItem('redirectTo', this.router.url);
    }
    //this.cookie.set("token", "null", new Date("2099-09-18"), "/", this.environment.cookieDomain);
    this.router.navigate(['/login'], { skipLocationChange: false });
  }

  clearToken() {
    let fulltoken = this.getTokenAllEnvs();
    if (!fulltoken) {
      fulltoken = {};
    }
    fulltoken[this.environment.env_name] = null;
    this.cookie.set(
      'token',
      JSON.stringify(fulltoken),
      new Date('2099-09-18'),
      '/',
      this.environment.cookieDomain
    );
  }

  isLoggedIn(): boolean {
    let res = true;
    let token = this.getWholeToken();
    if (token === null || token === '') {
      res = false;
    } else {
      let now = new Date();
      let expiration = new Date(token.expiration + ' GMT+00:00');

      // if token not expired
      if (now >= expiration) {
        res = false;
        this.clearToken();
        //this.cookie.set("token", "null", new Date("2099-09-18"), "/", this.environment.cookieDomain);
      }
    }

    //if(!res && !this.router.isActive('/login', true)) {
    //   this.router.navigate(['/login'],{skipLocationChange: false});
    //}
    return res;
  }
}
